exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image {\n  border-radius: 64px;\n  overflow: hidden;\n  margin-right: 1rem; }\n  .image img {\n    height: 100%;\n    width: auto;\n    max-width: unset;\n    min-width: 100%; }\n\n.media-left {\n  display: -ms-flexbox;\n  display: flex; }\n\n.content-title {\n  color: #204173;\n  margin-bottom: 0.2em;\n  margin-top: 0.5em; }\n\np {\n  color: #808d95; }\n\n.fa {\n  color: #738CA1;\n  margin-right: 8px; }\n\n.level-item {\n  color: #738CA1;\n  margin-right: 32px; }\n\n.user {\n  color: #3E8157; }\n\n.media {\n  margin-bottom: 32px;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  max-width: 750px; }\n\n.name {\n  -ms-flex-item-align: center;\n      -ms-grid-row-align: center;\n      align-self: center; }\n\n.level-left {\n  padding-left: 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /mnt/d/Projects/angular/chisparural-foro/src/app/forum/forum-item/forum-item.component.scss
// module id = ../../../../../src/app/forum/forum-item/forum-item.component.scss
// module chunks = 1